import React, { useState } from 'react'
import { BoxAviso, Icone, Texto, IconeClose } from './Styled'
import icAviso from 'images/icons/ic-aviso-renovacao.svg'
import icFecha from 'images/icons/ic-close-aviso.svg'

export default function Aviso ({ mensagem }) {

    const [aviso, setAviso] = useState(true)
 
    const fechaAviso = () => {
        setAviso(false)
    }

    const returnHtml = () => (
        <BoxAviso>
            <Icone src={icAviso} />
            <Texto dangerouslySetInnerHTML={{__html: mensagem}} />
            <IconeClose src={icFecha} onClick={fechaAviso} />
        </BoxAviso>
    )

    return aviso ? returnHtml() : null
}
